import { render } from "./ImportAttivitaExcel.vue?vue&type=template&id=3ad15f5e"
import script from "./ImportAttivitaExcel.vue?vue&type=script&lang=js"
export * from "./ImportAttivitaExcel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__